import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SubDomainEnum } from '../models/subdomain.enum';
import { StringDecoder } from 'string_decoder';

@Injectable({
  providedIn: 'root'
})
export class IframeService {

  public portalSessionCount = 0;

  // Indicator Frame Service
  private indicatorSource = new Subject<string>();
  public indicatorSource$ = this.indicatorSource.asObservable();

  private indicatorVisibility = new Subject<boolean>();
  public indicatorVisibility$ = this.indicatorVisibility.asObservable();

  private indicatorFrameLoaded = new Subject<void>();
  public indicatorFrameLoaded$ = this.indicatorFrameLoaded.asObservable();

  // Portal Frame Service
  private portalSource = new Subject<string>();
  public portalSource$ = this.portalSource.asObservable();

  private portalVisibility = new Subject<boolean>();
  public portalVisibility$ = this.portalVisibility.asObservable();

  private portalFrameLoaded = new Subject<void>();
  public portalFrameLoaded$ = this.portalFrameLoaded.asObservable();

  // Portal Session Frame Service
  // private portalSessionSource = new Subject<string>();
  // public portalSessionSource$ = this.portalSessionSource.asObservable();

  // Validation Client  Frame Service
  private validationSource = new Subject<string>();
  public validationSource$ = this.validationSource.asObservable();

  private validationVisibility = new Subject<boolean>();
  public validationVisibility$ = this.validationVisibility.asObservable();

  private validationFrameLoaded = new Subject<void>();
  public validationFrameLoaded$ = this.validationFrameLoaded.asObservable();

  // Performance Report Client  Frame Service
  private performanceSource = new Subject<string>();
  public performanceSource$ = this.performanceSource.asObservable();

  private performanceVisibility = new Subject<boolean>();
  public performanceVisibility$ = this.performanceVisibility.asObservable();

  private performanceFrameLoaded = new Subject<void>();
  public performanceFrameLoaded$ = this.performanceFrameLoaded.asObservable();

  // Learning Management Client  Frame Service
  private learningMngSource = new Subject<string>();
  public learningMngSource$ = this.learningMngSource.asObservable();

  private learningMngVisibility = new Subject<boolean>();
  public learningMngVisibility$ = this.learningMngVisibility.asObservable();

  private learningMngFrameLoaded = new Subject<void>();
  public learningMngFrameLoaded$ = this.learningMngFrameLoaded.asObservable();

  // System Management Client  Frame Service
  private sysMngSource = new Subject<string>();
  public sysMngSource$ = this.sysMngSource.asObservable();

  private sysMngVisibility = new Subject<boolean>();
  public sysMngVisibility$ = this.sysMngVisibility.asObservable();

  private sysMngFrameLoaded = new Subject<void>();
  public sysMngFrameLoaded$ = this.sysMngFrameLoaded.asObservable();

  // Micro Strategy Client  Frame Service
  // private microStratSource = new Subject<string>();
  // public microStratSource$ = this.microStratSource.asObservable();

  // private microStratVisibility = new Subject<boolean>();
  // public microStratVisibility$ = this.microStratVisibility.asObservable();

  // private microStratFrameLoaded = new Subject<void>();
  // public microStratFrameLoaded$ = this.microStratFrameLoaded.asObservable();

  // NDNQI Foundation Client - Unit Management -  Frame Service
  private ndnqiFoundationSource = new Subject<string>();
  public ndnqiFoundationSource$ = this.ndnqiFoundationSource.asObservable();

  private ndnqiFoundationVisibility = new Subject<boolean>();
  public ndnqiFoundationVisibility$ = this.ndnqiFoundationVisibility.asObservable();

  private ndnqiFoundationFrameLoaded = new Subject<void>();
  public ndnqiFoundationFrameLoaded$ = this.ndnqiFoundationFrameLoaded.asObservable();

  // Public Reports Client  Frame Service
  private ndnqiPublicReportsSource = new Subject<string>();
  public ndnqiPublicReportsSource$ = this.ndnqiPublicReportsSource.asObservable();

  // private ndnqiPublicReportsVisibility = new BehaviorSubject<boolean>(false);
  private ndnqiPublicReportsVisibility = new Subject<boolean>();
  public ndnqiPublicReportsVisibility$ = this.ndnqiPublicReportsVisibility.asObservable();

  private ndnqiPublicReportsFrameLoaded = new Subject<void>();
  public ndnqiPublicReportsFrameLoaded$ = this.ndnqiPublicReportsFrameLoaded.asObservable();

  private _loadingLinkId = '';
  get LoadingLinkId(): string {
    return this._loadingLinkId;
  }
  set LoadingLinkId(linkid: string) {
    this._loadingLinkId = linkid;
  }

  constructor() { }

  public setLinkId(path: string) {
    let linkId = '';
    if (path) {
      const pathParts = path.split('linkid=');
      if (pathParts && pathParts.length > 1) {
        linkId = pathParts[1];
      }
    }
    this.LoadingLinkId = linkId;
  }


  // IF
  public setIndicatorFrameSource(val: string) {
    // this.setLinkId(val);
    this.indicatorSource.next(val);
  }

  public setIndicatorFrameVisibility(val: boolean) {
    this.indicatorVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.IndicatorFactory); }
  }

  public onIndicatorFrameLoaded() {
    this.indicatorFrameLoaded.next();
  }

  private ensureHttpsInProduction(url: string): string {
    let result = url;
    const shouldEnforceHttps = environment.production === true && 
                               (environment.environment === 'PROD' || environment.environment === 'UAT');
    if (url && shouldEnforceHttps && url.startsWith('http://')) {
      result = url.replace('http://', 'https://');
    }
    return result;
  }

  // Portal
  public setPortalFrameSource(val: string) {
    this.portalSource.next(this.ensureHttpsInProduction(val));
  }

  public setPortalFrameVisibility(val: boolean) {
    this.portalVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.Portal); }
  }

  public onPortalFrameLoaded() {
    this.portalFrameLoaded.next();
  }

  // Portal Session
  // public setPortalSessionFrameSource(val: string) {
  //   this.portalSessionSource.next(val);
  // }

  // Validation
  public setValidationFrameSource(val: string) {
    this.validationSource.next(this.ensureHttpsInProduction(val));
  }

  public setValidationFrameVisibility(val: boolean) {
    this.validationVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.ValidationEngine); }
  }

  public onValidationFrameLoaded() {
    this.validationFrameLoaded.next();
  }

  // NDNQI Public Reports
  public setPublicReportsFrameSource(val: string) {
    this.ndnqiPublicReportsSource.next(this.ensureHttpsInProduction(val));
  }

  public setNdnqiPublicReportsFrameVisibility(val: boolean) {
    this.ndnqiPublicReportsVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.NdnqiPublicReports); }
  }

  public onPublicReportsFrameLoaded() {
    this.ndnqiPublicReportsFrameLoaded.next();
  }

  // Performance
  public setPerformanceFrameSource(val: string) {
    this.performanceSource.next(this.ensureHttpsInProduction(val));
  }

  public setPerformanceFrameVisibility(val: boolean) {
    this.performanceVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.PerformanceReports); }
  }

  public onPerformanceFrameLoaded() {
    this.performanceFrameLoaded.next();
  }

  // System Management
  public setSysManagementFrameSource(val: string) {
    this.sysMngSource.next(this.ensureHttpsInProduction(val));
  }

  public setSysManagementFrameVisibility(val: boolean) {
    this.sysMngVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.SystemManagement); }
  }

  public onSystemManagementFrameLoaded() {
    this.sysMngFrameLoaded.next();
  }

  // Micro Strategy
  // public setMicroStrategyFrameSource(val: string) {
  //   this.microStratSource.next(val);
  // }

  // public setMicroStrategyFrameVisibility(val: boolean) {
  //   this.microStratVisibility.next(val);
  //   if (val) { this.setNonVisibleFrames(SubDomainEnum.MicroStrategy); }
  // }

  // public onMicroStrategyFrameLoaded() {
  //   this.microStratFrameLoaded.next();
  // }

  // NDNQI Foundation: Unit Management
  public setNdnqiFoundationFrameSource(val: string) {
    this.ndnqiFoundationSource.next(this.ensureHttpsInProduction(val));
  }

  public setNdnqiFoundationFrameVisibility(val: boolean) {
    this.ndnqiFoundationVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.NdnqiFoundation); }
  }

  public onNdnqiFoundationFrameLoaded() {
    this.ndnqiFoundationFrameLoaded.next();
  }

  // Learning Management
  public setLearningManagementFrameSource(val: string) {
    this.learningMngSource.next(this.ensureHttpsInProduction(val));
  }

  public setLearningManagementFrameVisibility(val: boolean) {
    this.learningMngVisibility.next(val);
    if (val) { this.setNonVisibleFrames(SubDomainEnum.LearningManagement); }
  }

  public onLearningManagementFrameLoaded() {
    this.learningMngFrameLoaded.next();
  }

  // Set Sub Domain pages to Blank
  public setSubDomainsToBlank() {
    // this.setPortalFrame(environment.PortalBlankPage);
    this.setNonVisiblePortalFrame(); // SessionPage is called
    this.portalVisibility.next(false);

    this.setIndicatorFrameSource(environment.BlankPage);
    this.indicatorVisibility.next(false);
    this.setValidationFrameSource(environment.BlankPage);
    this.validationVisibility.next(false);
    this.setPerformanceFrameSource(environment.BlankPage);
    this.performanceVisibility.next(false);
    this.setLearningManagementFrameSource(environment.BlankPage);
    this.learningMngVisibility.next(false);
    this.setPublicReportsFrameSource(environment.BlankPage);
    this.ndnqiPublicReportsVisibility.next(false);
    this.setNdnqiFoundationFrameSource(environment.BlankPage);
    this.ndnqiFoundationVisibility.next(false);
    this.setSysManagementFrameSource(environment.BlankPage);
    this.sysMngVisibility.next(false);

    // const defaultMicroStratUrl = `${environment.PortalWebServer}/MicroStrategy.aspx`;
    // this.setMicroStrategyFrameSource(defaultMicroStratUrl);
    // this.microStratVisibility.next(false);
  }

  // Prevent flicker when switching between sites. Ensure Portal Session page is called
  public setNonVisibleFrames(visibleSubDomain: SubDomainEnum) {
    // if ((visibleSubDomain !== SubDomainEnum.Portal) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
    //   this.setPortalSessionFrame();
    // }
    if ((visibleSubDomain !== SubDomainEnum.Portal) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setNonVisiblePortalFrame();
    }

    // if ((visibleSubDomain !== SubDomainEnum.MicroStrategy) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
    //   const defaultMicroStratUrl = `${environment.PortalWebServer}/MicroStrategy.aspx`;
    //   this.setMicroStrategyFrameSource(defaultMicroStratUrl);
    //   this.microStratVisibility.next(false);
    // }

    if ((visibleSubDomain !== SubDomainEnum.IndicatorFactory) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setIndicatorFrameSource(environment.BlankPage);
      this.indicatorVisibility.next(false);
    }
    if ((visibleSubDomain !== SubDomainEnum.ValidationEngine) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setValidationFrameSource(environment.BlankPage);
      this.validationVisibility.next(false);
    }
    if ((visibleSubDomain !== SubDomainEnum.PerformanceReports) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setPerformanceFrameSource(environment.BlankPage);
      this.performanceVisibility.next(false);
    }
    if ((visibleSubDomain !== SubDomainEnum.LearningManagement) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setLearningManagementFrameSource(environment.BlankPage);
      this.learningMngVisibility.next(false);
    }
    if ((visibleSubDomain !== SubDomainEnum.NdnqiPublicReports) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setPublicReportsFrameSource(environment.BlankPage);
      this.ndnqiPublicReportsVisibility.next(false);
    }
    if ((visibleSubDomain !== SubDomainEnum.NdnqiFoundation) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setNdnqiFoundationFrameSource(environment.BlankPage);
      this.ndnqiFoundationVisibility.next(false);
    }
    if ((visibleSubDomain !== SubDomainEnum.SystemManagement) && (visibleSubDomain !== SubDomainEnum.NotSet)) {
      this.setSysManagementFrameSource(environment.BlankPage);
      this.sysMngVisibility.next(false);
    }

  }

  public setAllIFrames(visibleSubDomain: SubDomainEnum, path: string) {
    this.setNonVisibleFrames(visibleSubDomain);

    switch (visibleSubDomain) {
      case SubDomainEnum.Portal:
        this.setPortalFrameSource(path);
        this.portalVisibility.next(true);
        break;
      case SubDomainEnum.IndicatorFactory:
        this.setIndicatorFrameSource(path);
        this.indicatorVisibility.next(true);
        break;
      case SubDomainEnum.ValidationEngine:
        this.setValidationFrameSource(path);
        this.validationVisibility.next(true);
        break;
      case SubDomainEnum.PerformanceReports:
        this.setPerformanceFrameSource(path);
        this.performanceVisibility.next(true);
        break;
      case SubDomainEnum.LearningManagement:
        this.setLearningManagementFrameSource(path);
        this.learningMngVisibility.next(true);
        break;
      case SubDomainEnum.NdnqiPublicReports:
        this.setPublicReportsFrameSource(path);
        this.ndnqiPublicReportsVisibility.next(true);
        break;
      case SubDomainEnum.NdnqiFoundation:
        this.setNdnqiFoundationFrameSource(path);
        this.ndnqiFoundationVisibility.next(true);
        break;
      case SubDomainEnum.SystemManagement:
        this.setSysManagementFrameSource(path);
        this.sysMngVisibility.next(true);
        break;
    }
  }

  public setPortalFrame(path: string) {
    this.setPortalFrameSource(path);
  }

  public getSessionPage(): string {
    const sessionPage = `${environment.PortalSessionPage}?count=${this.portalSessionCount}`;
    return sessionPage;
  }

  public getSessionPath(): string {
    const sessionPage = `${environment.PortalSessionPath}?count=${this.portalSessionCount}`;
    return sessionPage;
  }

   public setNonVisiblePortalFrame() {
    const sessionPage = this.getSessionPage();
     this.setPortalFrameSource(sessionPage);
     this.portalSessionCount++;
   }

}
